import { getFetchWrapper } from "@syf-api-library/core";
import { creditHealthUrl } from "../endpoints.js";
const queryFnFactory = (config, keyProps) => {
  const fetchWrapper = getFetchWrapper(config);
  return () => {
    const params = new URLSearchParams({
      "cipher.accountId": keyProps.accountId
    });
    if (keyProps.accountIdType) {
      params.set("accountIdType", keyProps.accountIdType);
    }
    return fetchWrapper(`${creditHealthUrl}?${params}`, {
      method: "GET",
      headers: {
        "Accept-Language": config.lang
      }
    });
  };
};
export {
  queryFnFactory as default
};
//# sourceMappingURL=query.js.map
